import { render, staticRenderFns } from "./AppDownload.vue?vue&type=template&id=6fa99132&scoped=true"
import script from "./AppDownload.vue?vue&type=script&lang=js"
export * from "./AppDownload.vue?vue&type=script&lang=js"
import style0 from "./AppDownload.vue?vue&type=style&index=0&id=6fa99132&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa99132",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fa99132')) {
      api.createRecord('6fa99132', component.options)
    } else {
      api.reload('6fa99132', component.options)
    }
    module.hot.accept("./AppDownload.vue?vue&type=template&id=6fa99132&scoped=true", function () {
      api.rerender('6fa99132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/AppDownload.vue"
export default component.exports